import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useStyles } from './LayoutIndexPage.style'
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
  Box
} from '@material-ui/core'
import { Add, Delete, Edit, ArrowBack } from '@material-ui/icons'
import { reset, loadLocation } from '~/state/modules/locations'
import { loadLayouts, deleteLayout } from '~/state/modules/planimetry'
import SectorsButton from './SectorsButton'
import {
  TableGrid,
  createColumn,
  createCustomColumn,
  TableGridOrder
} from '~/views/shared'
import { PaperContainer, DeleteDialog } from '~/views/shared'
import history from '~/config/history'
import { ROUTES } from '~/views/routes'
import { ImageDialog } from './SectorIndexPage/ImageDialog'
import { showSnackbarError } from 'views/utils/snackbar'

const makeColumns = (
  setSelectedLayout,
  setShowDeleteDialog,
  locationId,
  setOpenDialog
) => {
  return [
    createColumn('Name', 'Nombre'),
    createCustomColumn(
      (l) => (
        <Box
          sx={{ cursor: 'pointer' }}
          onClick={() => {
            setSelectedLayout(l)
            setOpenDialog(true)
          }}>
          <img
            src={l.ImageCdnUrl}
            alt='plany'
            width={90}
            height={70}
            style={{
              objectFit: 'contain',
              borderRadius: 8,
              border: '1px solid #eee',
              display: 'block'
            }}
          />
        </Box>
      ),
      '\u00A0\u00A0\u00A0\u00A0Imagen'
    ),
    createCustomColumn(
      (l) => <SectorsButton layout={l} locationId={locationId} />,
      'Sectores'
    ),
    createCustomColumn(
      (l) => (
        <Button
          onClick={() => {
            history.push(
              ROUTES.ADMIN.LOCATIONS.PLANIMETRY.UPDATE.replace(
                ':locationId',
                locationId
              ).replace(':layoutId', l.Id)
            )
          }}>
          <Edit />
        </Button>
      ),
      'Editar'
    ),
    createCustomColumn(
      (c) => (
        <Button
          onClick={() => {
            setSelectedLayout(c)
            setShowDeleteDialog(true)
          }}>
          <Delete />
        </Button>
      ),
      'Eliminar'
    )
  ]
}

export const LayoutIndexPage = ({ match }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { location } = useSelector((state) => state.locations)
  const { pagedLayouts, pendingLayouts, pendingDeleteLayout, reqParams } =
    useSelector((state) => state.planimetry)
  const [selectedLayout, setSelectedLayout] = useState(null)
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const { locationId } = match.params

  const [open, setOpen] = useState(false)

  const handleClose = async () => {
    setOpen(false)
    await dispatch(reset())
    dispatch(
      loadLayouts(locationId, {
        searchParams: '',
        pageNumber: 0,
        orderBy: 'Name',
        order: TableGridOrder.ASC
      })
    )
    dispatch(loadLocation(locationId))
  }

  const handleDelete = async () => {
    try {
      await dispatch(deleteLayout(selectedLayout?.Id))
      setShowDeleteDialog(false)
      setOpen(true)
    } catch (error) {
      showSnackbarError(error)
    }
  }

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadLocation(locationId))
    }

    fetchData().then()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <PaperContainer
        title={
          <div className={classes.titleContainer}>
            <Typography className={classes.title}>
              {`Listado de Planimetrias de "${location?.Name ?? '-'}"`}
            </Typography>
            <Button
              onClick={() => history.push(ROUTES.ADMIN.LOCATIONS.INDEX)}
              color='primary'
              startIcon={<ArrowBack />}>
              Volver a Lugares
            </Button>
          </div>
        }>
        <TableGrid
          title={''}
          rowClasses={(x) => x?.IsEnabled && `${classes.conditionalRow}`}
          columns={makeColumns(
            setSelectedLayout,
            setShowDeleteDialog,
            locationId,
            setOpenDialog
          )}
          loadItemsPage={(x) => {
            dispatch(
              loadLayouts(locationId, {
                searchParams: '',
                pageNumber: 0,
                orderBy: 'Name',
                order: x.order
              })
            )
          }}
          isLoading={pendingLayouts}
          pagedList={pagedLayouts}
          keyName='Id'
          order={reqParams?.order || TableGridOrder.ASC}
          orderBy={reqParams?.orderBy || 'Name'}
          useNewFormat
          hideFooter
        />
        <div className={classes.createButtonContainer}>
          <Button
            onClick={() =>
              history.push(
                ROUTES.ADMIN.LOCATIONS.PLANIMETRY.CREATE.replace(
                  ':locationId',
                  locationId
                )
              )
            }
            color='primary'
            variant='contained'
            startIcon={<Add />}>
            Crear
          </Button>
        </div>
      </PaperContainer>
      <DeleteDialog
        open={showDeleteDialog}
        loading={pendingDeleteLayout}
        handleDelete={handleDelete}
        onCancel={() => setShowDeleteDialog(false)}
        title={'Eliminar Planimetria'}
        message={'Está por eliminar la planimetria'}
        entityIdentifier={selectedLayout?.Name}
      />
      <Dialog open={open}>
        <DialogTitle>Planimetria eliminada</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color='primary' autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <ImageDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        layoutName={selectedLayout?.Name}
        imageLayout={selectedLayout?.ImageCdnUrl}
      />
    </>
  )
}

export default LayoutIndexPage
